import React from 'react';
import css from '../css/Panel.module.css'
import {Col, Container, Row} from "react-bootstrap";

const Panel = ({children, fullWidth = true, center = false, className,...props}) => {
    return (
        <Container fluid={fullWidth} className={className}>
            <Row className={center ? 'justify-content-center' : ''}>
                <Col className={css.wrapper} {...props}>
                    {children}
                </Col>
            </Row>
        </Container>
    );
};

export default Panel;